let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jVjiX")).then(() => parcelRequire('4948p'));